module.exports = __webpack_public_path__ + "img/1000liters to 1bakkie.2fac4861.svg";